module.exports = __webpack_public_path__ + "img/propuesta_18msi.7abcb149.svg";